var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('h3',[_vm._v("n8shell v30")])]),_c('v-main',{staticClass:"main"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }